import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { CronogramaActividadesDTO, InfoActividadProyeccion } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class CronogramaActividadesService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getCronogramaActividadesService(): Observable<BodyListResponse<CronogramaActividadesDTO>> {
    return this.http.get<BodyListResponse<CronogramaActividadesDTO>>(API_URL + '/api/v1/cronogramaActividades/todos');
  }

  guardarCronogramaActividadesService(cronogramaActividadesDTO: CronogramaActividadesDTO): Observable<BodyResponse<CronogramaActividadesDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/cronogramaActividades', cronogramaActividadesDTO);
  }

  getCronogramaActividadesPorCodigoService(codigo: string): Observable<BodyResponse<CronogramaActividadesDTO>> {
    return this.http.get<BodyResponse<CronogramaActividadesDTO>>(API_URL + '/api/v1/cronogramaActividades/' + codigo);
  }
  /***** */

  getCronogramaActividadesPorProyectoService(codigo: string): Observable<BodyListResponse<CronogramaActividadesDTO>> {
    return this.http.get<BodyListResponse<CronogramaActividadesDTO>>(API_URL + '/api/v1/cronogramaActividades/proyecto/' + codigo);
  }

  getCronogramaActividadesPorProyectoNivelService(codigo: string): Observable<BodyListResponse<InfoActividadProyeccion>> {
    return this.http.get<BodyListResponse<InfoActividadProyeccion>>(API_URL + '/api/v1/cronogramaActividades/proyecto/nivel/' + codigo);
  }


  getCronogramaActividadesPorAnioMesProyectoService(anio: string, mes: string, codigo: string): Observable<BodyListResponse<CronogramaActividadesDTO>> {
    return this.http.get<BodyListResponse<CronogramaActividadesDTO>>(API_URL + '/api/v1/cronogramaActividades/proyecto/anio/mes/' + anio + '/' + mes + '/' + codigo);
  }

  getCronogramaActividadesPorAnioMesProyectoParticipantesService(anio: string, mes: string, codigoProyecto: string, codigoParticipante: string, estadoProyecto: string): Observable<BodyListResponse<CronogramaActividadesDTO>> {
    return this.http.get<BodyListResponse<CronogramaActividadesDTO>>(API_URL + '/api/v1/cronogramaActividades/proyecto/anio/mes/' + anio + '/' + mes + '/' + codigoProyecto + '/' + codigoParticipante + '/' + estadoProyecto);
  }
  // obtenerNumero de semanas por codigo proyecto
  /**
   * 
   * @param anio 
   * @param mes 
   * @param codigoProyecto 
   * @param codigoParticipante 
   * @param estadoProyecto 
   * @returns 
   */
  getCronogramaActividadesPorProyectoParticipantesService(codigoProyecto: string, codigoParticipante: string, estadoProyecto: string): Observable<BodyListResponse<CronogramaActividadesDTO>> {
    return this.http.get<BodyListResponse<CronogramaActividadesDTO>>(API_URL + '/api/v1/cronogramaActividades/proyecto/cronogramaActividades/' + codigoProyecto + '/' + codigoParticipante + '/' + estadoProyecto);
  }
  getNumeroSemanasPorCodigoProyecto(codigoProyecto: string): Observable<BodyResponse<any>> {
    return this.http.get<BodyResponse<any>>(API_URL + '/api/v1/cronogramaActividades/numeroSemanas/' + codigoProyecto);
  }


  obtenerActividadesPorParticipante(codigo: string): Observable<BodyListResponse<CronogramaActividadesDTO>> {
    return this.http.get<BodyListResponse<CronogramaActividadesDTO>>(API_URL + '/api/v1/cronogramaActividades/participantes/' + codigo);
  }

}
